module.exports = __webpack_public_path__ + "img/score10.4d80a670.png";